module.exports = __webpack_public_path__ + "static/datepicker-screenshot-db187c4177f35696f976509be8500f36.png";